window.OpportunitiesTasksSearch = {
  searchObject: {},

  initializeSearch(indexParams, searchParams) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this.searchObject = this._initializeSearchObject();
    this._addWidgets();
    this.searchObject.start();
  },

  initializeDashboardTasksSidebar(indexParams, searchParams) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this.searchObject = this._initializeSearchObject();
    this.searchObject.addWidgets([
      instantsearch.widgets.configure(searchParams),
      OpportunityWidgets.tasksHits(),
      this._dashboardIntelligenceTasksStatsWidget()
    ]);
    this.searchObject.start();
  },

  _initializeSearchObject() {
    return instantsearch({
      searchClient: algoliasearch(this.indexParams.appId, this.indexParams.key),
      indexName: this.indexParams.name,
      routing: true
    });
  },

  _dashboardIntelligenceTasksStatsWidget() {
    return instantsearch.widgets.stats({
      container: '#number-of-results',
      templates: {
        text(data) {
          const count = data.nbHits > data.hitsPerPage ? data.hitsPerPage : data.nbHits;
          return I18n.t('dashboards.intelligence.pending_tasks.results', { count, results: data.nbHits });
        }
      }
    });
  },

  _addWidgets() {
    this.searchObject.addWidgets([
      instantsearch.widgets.configure(this.searchParams),
      OpportunityWidgets.tasksHits(),
      OpportunityWidgets.searchBoxWidget(),
      OpportunityWidgets.statusWidget(),
      OpportunityWidgets.descriptionWidget(),
      OpportunityWidgets.dateMenuWidget('due_date_int'),
      OpportunityWidgets.typeFilter(),
      OpportunityWidgets.opportunitiesFilter(),
      OpportunityWidgets.assignedToFilter(),
      Widgets.currentRefinedValuesWidget()(),
      Widgets.clearAllWidget(),
      Widgets.statsWidget(),
      Widgets.paginationWidget()
    ]);
  }
};
